/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Away_Moth_GazeInputs */

const es_fair_away_moth_gaze = /** @type {(inputs: Fair_Away_Moth_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear cuenta`)
};

const gl_fair_away_moth_gaze = /** @type {(inputs: Fair_Away_Moth_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear conta`)
};

const en_fair_away_moth_gaze = /** @type {(inputs: Fair_Away_Moth_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create account`)
};

/**
* | output |
* | --- |
* | "Create account" |
*
* @param {Fair_Away_Moth_GazeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const fair_away_moth_gaze = /** @type {((inputs?: Fair_Away_Moth_GazeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Away_Moth_GazeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_fair_away_moth_gaze(inputs)
	if (locale === "en") return en_fair_away_moth_gaze(inputs)
	return es_fair_away_moth_gaze(inputs)
});